export default {
  "title": {
    "travels": "Viajes",
    "mainIndicators": "Principales indicadores conductuales",
    "dailyBehaviorGrade": "Nota conductual diaria",
    "travelDetail": "Detalle nota conductual viaje",
    "travelMainIndicators": "Indicadores viaje",
    "drivers": "conductores",
    "driverSleeps": "Eventos de somnolencia",
    "team": "EQUIPO"
  },
  "labels": {
    "behaviorGrade": "Nota conductual",
    "average": "Promedio"
  },
  "graphTooltip": {
    "behaviorGrade": "Nota día"
  },
  "buttons": {
    "travelDetail": "Detalle viaje"
  },
  "table": {
    "travel": "Viaje",
    "grade": "Nota conductual"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/behavior/driverBehavior.js